var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project_-_Edit",
    "data-name": "Project - Edit",
    transform: "translate(-429 -629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4383",
    "data-name": "Rectangle 4383",
    transform: "translate(429 629)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "edit-svgrepo-com",
    d: "M13.174,3.6a3,3,0,0,1,2.279-.281,3.068,3.068,0,0,1,.9.443c.26.176.558.409.9.679l.05.039c.346.27.644.5.878.712a3.071,3.071,0,0,1,.65.77,3,3,0,0,1,.281,2.279,3.069,3.069,0,0,1-.443.9c-.176.26-.409.558-.679.9l-7.1,9.1-.053.068a6.693,6.693,0,0,1-.9,1.016,4,4,0,0,1-.869.563,6.7,6.7,0,0,1-1.294.4l-.084.021-2.125.524c-.147.036-.315.078-.463.1a1.519,1.519,0,0,1-.7-.042,1.5,1.5,0,0,1-.817-.638,1.518,1.518,0,0,1-.212-.672c-.014-.149-.014-.322-.015-.474q0-.014,0-.028L3.355,17.83v-.086a6.694,6.694,0,0,1,.078-1.354,4,4,0,0,1,.336-.98,6.693,6.693,0,0,1,.768-1.118l.053-.068,7.1-9.1c.27-.346.5-.644.712-.878A3.069,3.069,0,0,1,13.174,3.6Zm1.745,1.647a1,1,0,0,0-.76.094,1.159,1.159,0,0,0-.266.244c-.159.177-.35.421-.645.8L16.4,8.841c.3-.378.485-.622.618-.819a1.157,1.157,0,0,0,.173-.318,1,1,0,0,0-.094-.76,1.161,1.161,0,0,0-.244-.266c-.177-.159-.421-.35-.8-.645s-.623-.485-.819-.618A1.16,1.16,0,0,0,14.919,5.243Zm.252,5.175L12.018,7.957l-5.852,7.5a5.644,5.644,0,0,0-.605.842,2,2,0,0,0-.168.49,5.647,5.647,0,0,0-.038,1.036l.006,1.913,1.857-.458a5.636,5.636,0,0,0,1-.288,2,2,0,0,0,.435-.282,5.646,5.646,0,0,0,.67-.792ZM12,21a1,1,0,0,1,1-1h7a1,1,0,0,1,0,2H13A1,1,0,0,1,12,21Z",
    transform: "translate(426.646 626.793)",
    fill: "#666",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProject);
export default __webpack_public_path__ + "static/media/editProject.75170e798191d1fea28aa77299f14e22.svg";
export { ForwardRef as ReactComponent };